// src/components/DataTable.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';

import { saveAs } from 'file-saver';

import DTTable from '../../components/AntdTable';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import HorizontalForm from '../../components/HorizontalForm';
import ModalForm from '../../components/ModalForm';
import { useTranslation } from 'react-i18next';
import ActivityReport from './ActivityReport';
import MapView from '../../components/MapView';
import { fetchForm } from '../../utils/ktcUtils';
import BalanceSheet from './Accounting/BalanceSheet';
import TrialBalance from './Accounting/TrialBalance';
import ActivityReport2 from './ActivityReport2';
import IncomeStatement from './Accounting/IncomeStatement';
import ReceiptForm from '../../components/ReceiptForm';
import CustomParentReceipt from '../aqoonkaal/CustomParentReceipt';
import BalanceSheetSubSections from './Accounting/BalanceSheetSubSections';
import image401 from '../../images/401.png';

const ReportForm = () => {
  const { t } = useTranslation();
  const [report, setReport] = useState([]);
  const [reportHeader, setReportHeader] = useState([]);
  const [reportFooter, setReportFooter] = useState([]);
  const [permissions, setPermissions] = useState([]);

  const token = getToken();
  const userId = decodeToken(token, 'id');
  const branchId = decodeToken(token, 'branch_id');

  const [loading, setLoading] = useState(true);
  const { route } = useParams(); // Retrieve the param from the URL

  const [link, setLink] = useState([]);
  const [inputs, setInputs] = useState([]);
  const [values, setValues] = useState([]);

  const [executionTime, setExecutionTime] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentRoute, setCurrentRoute] = useState(null);

  const params = new URLSearchParams(window.location.search);
  const queryObj = Object.fromEntries(params.entries());

  const [formReportPer,setFormReportPer]=useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const openModal2 = (route) => {
    setCurrentRoute(route);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    setReport([]);
    const url = `${API_URL}/${ENDPOINTS.SYS}/createform/${route}`;

    fetchForm({
      url,
      queryObj,
      setLink,
      setInputs,
      setValues,
      setLoading,
      setFormReportPer
    });
  }, [route]);

  //console.log('link:', link);

  //activity report print
  const printAcivityReport = (e) => {
    e.preventDefault(); // Prevent default behavior of the Link
    console.log('rr:', JSON.stringify(report));
    localStorage.setItem('printData', ''); // Store data in localStorage
    localStorage.setItem('printData', JSON.stringify(report)); // Store data in localStorage
    localStorage.setItem('linkData', ''); // Store data in localStorage
    localStorage.setItem('linkData', JSON.stringify(link)); // Store data in localStorage
    localStorage.setItem('reportHeader', ''); // Store data in localStorage
    localStorage.setItem('reportHeader', JSON.stringify(reportHeader)); // Store data in localStorage
    console.log('JSON.stringify(reportHeader):', JSON.stringify(reportHeader));
    window.open('/print-activity', '_blank'); // Open the link in a new tab
  };

  // const exportToExcel = () => {
  //   if (!report || report.length === 0) return;

  //   const allRows = [];

  //   report.forEach((section) => {
  //     if (!section.table) return;

  //     // ✅ Clean title (remove <br/>)
  //     const title = (section.title || 'Section').replace(/<[^>]*>/g, '');

  //     // 👉 Add title row
  //     allRows.push([title]);

  //     // 👉 Prepare clean data
  //     const cleanData = section.table.map((row) => {
  //       const newRow = {};

  //       Object.keys(row).forEach((key) => {
  //         const cleanKey = key.split('~')[0]; // remove ~cell-color
  //         newRow[cleanKey] = row[key];
  //       });

  //       return newRow;
  //     });

  //     // 👉 Convert to sheet format
  //     const worksheetPart = XLSX.utils.json_to_sheet(cleanData, {
  //       skipHeader: false,
  //     });

  //     const data = XLSX.utils.sheet_to_json(worksheetPart, {
  //       header: 1,
  //     });

  //     // 👉 Add table rows
  //     data.forEach((row) => allRows.push(row));

  //     // 👉 Add empty row for spacing
  //     allRows.push([]);
  //     allRows.push([]);
  //   });

  //   // ✅ Create final worksheet
  //   const worksheet = XLSX.utils.aoa_to_sheet(allRows);

  //   // Optional: column width
  //   worksheet['!cols'] = allRows[0]?.map(() => ({ wch: 18 })) || [];

  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');

  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: 'xlsx',
  //     type: 'array',
  //   });

  //   const data = new Blob([excelBuffer], {
  //     type: 'application/octet-stream',
  //   });

  //   saveAs(data, 'activity_report.xlsx');
  // };

  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Report');

    let rowIndex = 1;

    // =========================
    // ✅ 1. ADD BANNER IMAGE
    // =========================
    try {
      const imageUrl = reportHeader?.banner; // e.g. "https://....jpg"

      if (imageUrl) {
        const res = await fetch(imageUrl);
        const blob = await res.blob();
        const buffer = await blob.arrayBuffer();

        const imageId = workbook.addImage({
          buffer,
          extension: 'jpeg', // or png
        });

        worksheet.addImage(imageId, {
          tl: { col: 0, row: 0 },
          ext: { width: 600, height: 120 },
        });

        rowIndex += 6; // space after image
      }
    } catch (err) {
      console.log('Image load failed', err);
    }

   
 
    // =========================
// ✅ 2. REPORT HEADER
// =========================

const headerObj = reportHeader?.[0] || {};
const values = Object.values(headerObj);

const totalColumns = 5; // 👈 change this to match your table width

values.forEach((value, index) => {
  const fontSizes = [24, 20, 18, 16, 14, 12];

  const row = worksheet.getRow(rowIndex);

  // Merge from column 1 → totalColumns
  worksheet.mergeCells(rowIndex, 1, rowIndex, totalColumns);

  const cell = row.getCell(1);
  cell.value = value;

  cell.font = {
    bold: true,
    size: fontSizes[index] || 12,
  };

  cell.alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  rowIndex++;
});
    // space
    rowIndex += 2;

    // =========================
    // ✅ 3. REPORT TABLES
    // =========================
    report.forEach((section) => {
      if (!section.table) return;

      const title = (section.title || '').replace(/<[^>]*>/g, '');

      // 👉 Section title
      const titleRow = worksheet.getRow(rowIndex);
      titleRow.getCell(1).value = title;
      titleRow.getCell(1).font = { bold: true, size: 16 };

      rowIndex++;

      // 👉 Clean data
      const cleanData = section.table.map((row) => {
        const newRow = {};

        Object.keys(row).forEach((key) => {
          const cleanKey = key.split('~')[0];
          newRow[cleanKey] = row[key];
        });

        return newRow;
      });

      if (cleanData.length === 0) return;

      const headers = Object.keys(cleanData[0]);

      // 👉 Header row
      const headerRow = worksheet.getRow(rowIndex);
      headers.forEach((h, i) => {
        const cell = headerRow.getCell(i + 1);
        cell.value = h;
        cell.font = { bold: true };
        cell.border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
        };
      });

      rowIndex++;

      // 👉 Data rows
      cleanData.forEach((dataRow) => {
        const row = worksheet.getRow(rowIndex);

        headers.forEach((h, i) => {
          row.getCell(i + 1).value = dataRow[h];
        });

        rowIndex++;
      });

      // space after section
      rowIndex += 2;
    });

    // =========================
    // ✅ 4. AUTO WIDTH
    // =========================
    worksheet.columns.forEach((col) => {
      col.width = 18;
    });

    // =========================
    // ✅ 5. EXPORT FILE
    // =========================
    const buffer = await workbook.xlsx.writeBuffer();

    saveAs(new Blob([buffer]), 'activity_report.xlsx');
  };
  const printAcivityReport2 = (e) => {
    e.preventDefault(); // Prevent default behavior of the Link

    localStorage.setItem('printData', ''); // Store data in localStorage
    localStorage.setItem('printData', JSON.stringify(report)); // Store data in localStorage
    localStorage.setItem('linkData', ''); // Store data in localStorage
    localStorage.setItem('linkData', JSON.stringify(link)); // Store data in localStorage
    localStorage.setItem('reportHeader', ''); // Store data in localStorage
    localStorage.setItem('reportHeader', JSON.stringify(reportHeader)); // Store data in localStorage

    window.open('/print-activity2', '_blank'); // Open the link in a new tab
  };
  if (
    !loading &&
    formReportPer.length>0 &&
    formReportPer[0]?.can_view !== 1 &&
    formReportPer[0]?.can_view !== true
  ) {
    console.log("form report permission: ",formReportPer);
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: `url(${image401})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          backgroundSize: "cover",
        }}
      >
      </div>
    );
  }
  return (
    <>
      {isModalOpen &&
        currentRoute &&
        (currentRoute === 'new-receipt2' ||
        currentRoute === 'new-bus-fee-receipt' ? (
          <ReceiptForm
            userId={userId}
            token={token}
            route={currentRoute}
            isOpen={isModalOpen}
            onRequestClose={closeModal}
          />
        ) : (
          <ModalForm
            userId={userId}
            token={token}
            route={currentRoute} // Pass the dynamic route to the modal
            isOpen={isModalOpen}
            onRequestClose={closeModal}
          />
        ))}

      <HorizontalForm
        token={token}
        link={link}
        values={values}
        inputs={inputs}
        setInputs={setInputs}
        setData={setReport}
        setReportHeader={setReportHeader}
        setReportFooter={setReportFooter}
        setPermissions={setPermissions}
        setValues={setValues}
        setExecutionTime={setExecutionTime}
        setHasSearched={setHasSearched}
      />

      {/* {report && report.length === 0 && 
        <p>No Data Found</p>
      }  */}

      {report &&
        report.length > 0 &&
        link.form_type === 'activity-report' &&
        API_URL.includes('kaah') && (
          <>
            <center>
              <button className="btn btn-danger" onClick={printAcivityReport2}>
                Print Report
              </button>
            </center>

            <ActivityReport2 sections={report} link={link} />
          </>
        )}

      {report &&
        report.length > 0 &&
        link.form_type === 'activity-report' &&
        !API_URL.includes('kaah') && (
          <>
            <center>
              <button className="btn btn-danger" onClick={printAcivityReport}>
                Print Report
              </button>
              <button className="btn btn-warning" onClick={exportToExcel}>
                Download Excel
              </button>
            </center>

            <ActivityReport
              sections={report}
              link={link}
              reportHeader={reportHeader}
              reportfooter={reportFooter}
            />
          </>
        )}

      {report &&
        report.length > 0 &&
        link.form_type === 'form-report' &&
        link.route === 'income-statement' && (
          <>
            <IncomeStatement report={report} link={link} value={values} />
          </>
        )}

      {report &&
        report.length > 0 &&
        link.form_type === 'form-report' &&
        link.route === 'balance-sheet' && (
          <>
            <BalanceSheet report={report} link={link} value={values} />
          </>
        )}
      {report &&
        report.length > 0 &&
        link.form_type === 'form-report' &&
        link.route === 'balance-sheet-sub-sections' && (
          <>
            <BalanceSheetSubSections
              report={report}
              link={link}
              value={values}
            />
          </>
        )}
      {report &&
        report.length > 0 &&
        link.form_type === 'form-report' &&
        link.route === 'trial-balance' && (
          <>
            <TrialBalance report={report} link={link} value={values} />
          </>
        )}
      {report && report.length > 0 && link.form_type === 'map-report' && (
        <MapView data={report} link={link} />
      )}
      {report &&
        report.length > 0 &&
        link.form_type === 'form-report' &&
        (link.route === 'sponser-report' ||
          link.route === 'student-bus-sponser' ||
          link.route === 'scholarship-students-report' ||
          link.route === 'fee-receipt-employee-student') && (
          <>
            <CustomParentReceipt report={report} link={link} value={values} />
          </>
        )}
      {report &&
        link.form_type !== 'activity-report' &&
        link.form_type !== 'map-report' &&
        link.route != 'balance-sheet' &&
        link.route != 'income-statement' &&
        link.route != 'trial-balance' &&
        link.route != 'sponser-report' &&
        link.route != 'student-bus-sponser' &&
        link.route != 'scholarship-students-report' &&
        link.route != 'fee-receipt-employee-student' && (
          <DTTable
            data={report}
            reportHeader={reportHeader}
            reportFooter={reportFooter}
            link={link}
            token={token}
            executionTime={executionTime}
            editDelPermission={permissions}
            hasSearched={hasSearched}
          />
        )}
    </>
  );
};

export default ReportForm;
